import React, { Component } from 'react';
// components
import { Link } from 'react-router-dom';
import { ProfilePicture, FontAwesome, InlineSync } from 'components/ui';
import { TabPane, Row, Col, Button } from 'reactstrap';
// functions
import { toast } from 'react-toastify';
import { updatePlatoonLevels } from 'store/base/platoons/platoon_transition';

const Soldier = props => {
  const { user_id, user_serial, first, last, profilePicture, rank } = props;
  return (
    <Row className='soldier'>
      <Col xs={ 3 } xl={ 2 }>
        <ProfilePicture src={ profilePicture } rank={ rank.rank_ord } />
      </Col>
      <Col xs={ 9 } xl={ 10 }>
        <Row>
          <Col xs={ 12 } xl={ 4 }>
            <strong>Serial Number: </strong>
            <p className='s-number'><Link to={`/bm/soldiers/${user_id}`}>{user_serial}</Link></p>
          </Col>
          <Col xs={ 12 } xl={ 8 }>
            <strong>Full Name: </strong>
            <p><Link to={`/bm/soldiers/${user_id}`}>{ rank.name } {first} {last}</Link></p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export class SoldiersTab extends Component {

  state = { updating: false }

  updateLevels = () => {
    const { platoon } = this.props;
    if ( !window.confirm(
      "This will update every soldier in this platoon to the age / level that matches the platoon's grade. Continue?"
    ) ) return;

    this.setState({ updating: true });
    updatePlatoonLevels( platoon.class_id )
      .then( ({ count }) => {
        toast.success(`Updated ${ count } soldier${ count === 1 ? '' : 's' } to the platoon's level.`);
        this.setState({ updating: false });
      })
      .catch( error => {
        toast.error( error.message );
        this.setState({ updating: false });
      });
  }

  render(){
    const { users, tabId } = this.props;
    const { updating } = this.state;

    return (
      <TabPane tabId={ tabId } id='SoldiersTab' >

        <h2>{ users.length } Soldiers</h2>

        <div id='soldiers'>
          { users.map( ( user, index ) =>
            <Soldier key={index} {...user} />
          )}
        </div>

        <Button
            color='primary'
            block
            disabled={ updating }
            onClick={ this.updateLevels }>
          { updating
            ? <span><InlineSync loading /> Updating...</span>
            : <span><FontAwesome icon='sync' /> Update Soldiers Age / Level to Platoon Level</span> }
        </Button>

      </TabPane>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/base-managment/platoons/tabs/SoldiersTab.jsx